export const ArrowRightGlobalNavigation = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M10 17C9.74404 17 9.48801 16.9021 9.29301 16.7071C8.90201 16.3161 8.90201 15.684 9.29301 15.293L12.586 12L9.29301 8.70707C8.90201 8.31607 8.90201 7.68401 9.29301 7.29301C9.68401 6.90201 10.3161 6.90201 10.7071 7.29301L14.7071 11.293C15.0981 11.684 15.0981 12.3161 14.7071 12.7071L10.7071 16.7071C10.5121 16.9021 10.256 17 10 17Z"
      fill="#232323"
    ></path>
  </svg>
)
